/** Formats a full name into an abbreviated form, e.g. "John Smith" -> "J. Smith". */
export const abbreviateName = (name?: string): string => {
  const parts = name?.trim().split(/\s+/).filter(Boolean) ?? [];

  if (parts.length === 0) {
    return 'Unknown user';
  }

  if (parts.length === 1) {
    return parts[0];
  }

  const [first, ...rest] = parts;

  return `${first.charAt(0).toUpperCase()}. ${rest.join(' ')}`;
};
